var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.syncOptionShow,
          expression: "syncOptionShow"
        }
      ],
      staticClass: "popup"
    },
    [
      _c("div", { staticClass: "content", attrs: { id: "syncOptions" } }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(
            "\r\n            " +
              _vm._s(_vm.$t("language.common.options")) +
              "\r\n            "
          ),
          _c("div", {
            staticClass: "icon white-close dialog-close",
            on: {
              click: function($event) {
                return _vm.optionClose()
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "transfer-options-body" }, [
          _c(
            "div",
            { staticClass: "transfer-options-cont" },
            [
              _c(
                "el-tabs",
                {
                  model: {
                    value: _vm.activeName,
                    callback: function($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName"
                  }
                },
                [
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("language.popup.syncModes"),
                        name: "first"
                      }
                    },
                    [_c("tab1", { ref: "tab1" })],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("language.popup.email"),
                        name: "second"
                      }
                    },
                    [_c("tab2", { ref: "tab2" })],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-tab-pane",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "transfer-vip",
                          attrs: { slot: "label", name: "third" },
                          slot: "label"
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("language.popup.filter")))
                          ]),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "icon-util vip filter-position"
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("tab3", { ref: "tab3" })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "transfer-options-footer" }, [
            _c(
              "button",
              {
                staticStyle: { float: "right" },
                on: {
                  click: function($event) {
                    return _vm.optionSubmit()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("language.common.save")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "white-button",
                staticStyle: { float: "right", "margin-right": "10px" },
                on: {
                  click: function($event) {
                    return _vm.optionClose()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("language.common.cancel")))]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0383cc10", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0383cc10","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/cloud_transfer_popups/sync_options_popup.vue
// module id = null
// module chunks = 